const DbPlugin = store => {
	console.log('db plugin, state=', store.state);

	// 每次 mutation 發生時被調用
	store.subscribe((mutation, state) => {
		console.log(
			`db plugin, mutation, type=,`,
			mutation.type,
			`, payload=`,
			mutation.payload?.value,
			`, state=`,
			state
		);
	});

	// 每次 action 發生時被調用
	store.subscribeAction((action, state) => {
		console.log(
			`db plugin, action, type=`,
			action.type,
			`, payload=`,
			action.payload?.value,
			`, state=`,
			state
		);
	});
};

export default DbPlugin;
